import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const STR = {
  brand: { en: "VATRdar", ar: "VATRdar" },
  brand_sub: { en: "A Growth Curve Product", ar: "منتج من Growth Curve" },
  footer_copy: { en: "All rights reserved © Growth Curve Professional Consultancy", ar: "جميع الحقوق محفوظة © Growth Curve للاستشارات المهنية" },

  // VATRdar Control
  nav_control: { en: "VAT Control", ar: "التحكم الضريبي" },
  ctrl_title: { en: "VAT Control Center", ar: "مركز التحكم الضريبي" },
  ctrl_sub: { en: "Upload ledgers per VAT period, validate transactions against VAT rules, and manage exceptions — figures computed in-system, review stays professional.", ar: "ارفع الدفاتر لكل فترة ضريبية، وتحقّق من المعاملات مقابل قواعد الضريبة، وأدِر الاستثناءات — الأرقام تُحسب برمجياً والمراجعة تبقى مهنية." },
  ctrl_client: { en: "Client", ar: "العميل" },
  ctrl_pick_client: { en: "Select a client", ar: "اختر عميلاً" },
  ctrl_pick_client_first: { en: "Select a client first.", ar: "اختر عميلاً أولاً." },
  ctrl_period: { en: "VAT period", ar: "الفترة الضريبية" },
  ctrl_no_period: { en: "No period selected", ar: "لا توجد فترة محددة" },
  ctrl_new_period: { en: "New period", ar: "فترة جديدة" },
  ctrl_create: { en: "Create", ar: "إنشاء" },
  ctrl_created: { en: "Period created", ar: "تم إنشاء الفترة" },
  ctrl_start_hint: { en: "Create or select a VAT period to begin.", ar: "أنشئ أو اختر فترة ضريبية للبدء." },
  ctrl_upload_sales: { en: "Upload sales ledger", ar: "رفع دفتر المبيعات" },
  ctrl_upload_purch: { en: "Upload purchases ledger", ar: "رفع دفتر المشتريات" },
  ctrl_rows_in: { en: "transactions ingested", ar: "معاملة أُدخلت" },
  ctrl_exc_created: { en: "exceptions", ar: "استثناء" },
  ctrl_health: { en: "VAT Health Check", ar: "فحص صحة الضريبة" },
  ctrl_tested: { en: "Transactions tested", ar: "معاملات مُختبرة" },
  ctrl_passed: { en: "Passed", ar: "ناجحة" },
  ctrl_warnings: { en: "Warnings", ar: "تحذيرات" },
  ctrl_exceptions: { en: "Exceptions", ar: "استثناءات" },
  ctrl_recon: { en: "Reconciliation completion", ar: "اكتمال المطابقة" },
  ctrl_material: { en: "Material exceptions", ar: "استثناءات جوهرية" },
  ctrl_high_risk: { en: "Unresolved high-risk", ar: "عالية المخاطر غير محلولة" },
  ctrl_review: { en: "Tax review required", ar: "تحتاج مراجعة ضريبية" },
  ctrl_sales_vat: { en: "Sales VAT", ar: "ضريبة المبيعات" },
  ctrl_purch_vat: { en: "Purchases VAT", ar: "ضريبة المشتريات" },
  ctrl_net_vat: { en: "Net VAT", ar: "صافي الضريبة" },
  ctrl_tx_explorer: { en: "Transaction Explorer", ar: "مستكشف المعاملات" },
  ctrl_exceptions_title: { en: "Exception Center", ar: "مركز الاستثناءات" },
  ctrl_all: { en: "All", ar: "الكل" },
  ctrl_search_inv: { en: "Invoice…", ar: "فاتورة…" },
  ctrl_no_tx: { en: "No transactions. Upload a ledger above.", ar: "لا توجد معاملات. ارفع دفتراً بالأعلى." },
  ctrl_no_exc: { en: "No exceptions in this period.", ar: "لا توجد استثناءات في هذه الفترة." },
  ctrl_col_invoice: { en: "Invoice", ar: "الفاتورة" },
  ctrl_col_ledger: { en: "Ledger", ar: "الدفتر" },
  ctrl_col_base: { en: "Base", ar: "الوعاء" },
  ctrl_col_vat: { en: "VAT", ar: "الضريبة" },
  ctrl_col_status: { en: "Status", ar: "الحالة" },
  ctrl_resolve: { en: "Resolve", ar: "حل" },
  ctrl_escalate: { en: "Escalate to advisory", ar: "تحويل لاستشارة" },
  ctrl_updated: { en: "Exception updated", ar: "تم تحديث الاستثناء" },
  ctrl_to_advisory: { en: "Create advisory case", ar: "إنشاء قضية استشارية" },
  ctrl_adv_created: { en: "Advisory case created", ar: "تم إنشاء قضية استشارية" },

  // Rules Engine
  nav_rules: { en: "VAT Rules", ar: "قواعد الضريبة" },
  rules_title: { en: "VAT Rules Engine", ar: "محرك قواعد الضريبة" },
  rules_sub: { en: "Tax-team managed, versioned validation rules. Disabling a rule stops it from raising new exceptions.", ar: "قواعد تحقّق يديرها فريق الضرائب بإصدارات. تعطيل القاعدة يوقف إنشاء استثناءات جديدة منها." },
  rules_updated: { en: "Rule updated (new version)", ar: "تم تحديث القاعدة (إصدار جديد)" },
  rule_col_id: { en: "Rule ID", ar: "معرّف القاعدة" },
  rule_col_name: { en: "Name", ar: "الاسم" },
  rule_col_cat: { en: "Category", ar: "الفئة" },
  rule_col_sev: { en: "Severity", ar: "الخطورة" },
  rule_col_ver: { en: "Version", ar: "الإصدار" },
  rule_col_on: { en: "Enabled", ar: "مفعّلة" },
  rule_enable: { en: "Enabled", ar: "مفعّلة" },
  rule_disable: { en: "Disabled", ar: "معطّلة" },

  // AI Toolkit — Reconciliation
  tk_tab_reconcile: { en: "Reconciliation", ar: "المطابقة" },
  rec_help: { en: "Upload the sales and/or purchases ledger (CSV or Excel). Columns are matched automatically (invoice, TIN, taxable amount, VAT). The amount column must be the value BEFORE VAT. Totals are computed in-system; AI only explains the result.", ar: "ارفع دفتر المبيعات و/أو المشتريات (CSV أو Excel). تُطابق الأعمدة تلقائياً (الفاتورة، الرقم الضريبي، المبلغ الخاضع، الضريبة). عمود المبلغ يجب أن يكون القيمة قبل الضريبة. الإجماليات تُحسب برمجياً، والذكاء الاصطناعي يشرح النتيجة فقط." },
  rec_sales_ledger: { en: "Sales ledger", ar: "دفتر المبيعات" },
  rec_purch_ledger: { en: "Purchases ledger", ar: "دفتر المشتريات" },
  rec_choose: { en: "Choose file", ar: "اختر ملفاً" },
  rec_decl_out: { en: "Declared output VAT", ar: "ضريبة المخرجات بالإقرار" },
  rec_decl_in: { en: "Declared input VAT", ar: "ضريبة المدخلات بالإقرار" },
  rec_rows: { en: "rows", ar: "سطر" },
  rec_base: { en: "Taxable base", ar: "الوعاء الخاضع" },
  rec_vat: { en: "VAT in ledger", ar: "الضريبة بالدفتر" },
  rec_expected_vat: { en: "Expected VAT (15%)", ar: "الضريبة المتوقعة (15%)" },
  rec_gap: { en: "Gap", ar: "الفرق" },
  rec_flagged: { en: "Flagged rows", ar: "أسطر مشبوهة" },
  rec_net: { en: "Net VAT (output − input)", ar: "صافي الضريبة (مخرجات − مدخلات)" },
  rec_vs_return: { en: "Ledger vs VAT return (variance)", ar: "الدفتر مقابل الإقرار (الفرق)" },
  rec_commentary: { en: "Specialist commentary (preliminary)", ar: "تعليق المختص (أولي)" },
  rec_checks: { en: "Recommended checks", ar: "فحوصات موصى بها" },
  rec_title: { en: "Ledger reconciliation", ar: "مطابقة الدفاتر" },
  rec_need_file: { en: "Upload at least one ledger file.", ar: "ارفع ملف دفتر واحداً على الأقل." },
  recflag_vat_mismatch: { en: "VAT ≠ 15%", ar: "الضريبة ليست 15%" },
  recflag_invalid_tin: { en: "Invalid TIN", ar: "رقم ضريبي غير صحيح" },
  recflag_missing_tin: { en: "Missing TIN", ar: "رقم ضريبي مفقود" },
  recflag_duplicate: { en: "Duplicate invoice", ar: "فاتورة مكررة" },
  recflag_zero_or_negative: { en: "Zero/negative amount", ar: "مبلغ صفري/سالب" },
  recflag_missing_vat: { en: "No VAT on taxable", ar: "لا ضريبة على مبلغ خاضع" },

  // Nav
  nav_home: { en: "Home", ar: "الرئيسية" },
  nav_how: { en: "How It Works", ar: "كيف تعمل" },
  nav_health: { en: "VAT Health Check", ar: "فحص صحة الضريبة" },
  nav_compliance: { en: "VAT Compliance", ar: "الامتثال الضريبي" },
  nav_advisory: { en: "VAT Advisory", ar: "الاستشارات الضريبية" },
  nav_zatca: { en: "ZATCA Audit Support", ar: "دعم فحص الهيئة" },
  nav_pricing: { en: "Pricing", ar: "الباقات" },
  nav_knowledge: { en: "Knowledge Center", ar: "مركز المعرفة" },
  nav_about: { en: "About", ar: "عن Growth Curve" },
  nav_contact: { en: "Contact", ar: "تواصل" },
  login: { en: "Login", ar: "تسجيل الدخول" },
  logout: { en: "Log out", ar: "تسجيل الخروج" },
  change_password: { en: "Change password", ar: "تغيير كلمة المرور" },
  cp_title: { en: "Change password", ar: "تغيير كلمة المرور" },
  cp_current: { en: "Current password", ar: "كلمة المرور الحالية" },
  cp_new: { en: "New password", ar: "كلمة المرور الجديدة" },
  cp_confirm: { en: "Confirm new password", ar: "تأكيد كلمة المرور الجديدة" },
  cp_submit: { en: "Update password", ar: "تحديث كلمة المرور" },
  cp_hint: { en: "Use at least 8 characters.", ar: "استخدم 8 أحرف على الأقل." },
  cp_mismatch: { en: "New passwords do not match.", ar: "كلمتا المرور غير متطابقتين." },
  cp_success: { en: "Password updated successfully.", ar: "تم تحديث كلمة المرور بنجاح." },
  dashboard: { en: "Dashboard", ar: "لوحة التحكم" },
  cta_check: { en: "Check Your VAT Health", ar: "افحص صحة ضريبتك" },
  cta_plans: { en: "View Plans", ar: "عرض الباقات" },
  cta_start: { en: "Start VAT Assessment", ar: "ابدأ التقييم الضريبي" },
  get_started: { en: "Get Started", ar: "ابدأ الآن" },

  // Hero
  hero_title: { en: "Your taxes, in expert hands.", ar: "ضرائبك في أيدٍ محترفة." },
  hero_sub: { en: "A specialist Saudi tax advisory team managing your VAT, Excise and Real Estate Transaction Tax with precision and professionalism — supported by regulation-grounded technology.", ar: "فريق استشاري ضريبي سعودي متخصّص يُدير ضريبة القيمة المضافة والانتقائية والتصرفات العقارية بدقّة واحترافية — تسنده تقنية مبنية على الأنظمة." },
  positioning: { en: "Professional tax consultants for your business — without building an internal tax department.", ar: "مستشارو ضرائب محترفون لمنشأتك — دون الحاجة لبناء إدارة ضريبية داخلية." },
  secondary_pos: { en: "Specialist-reviewed, supervisor-approved, quality-controlled.", ar: "مراجعة من مختصين، واعتماد المشرف، ورقابة جودة." },

  // How it works pipeline
  step_submission: { en: "Client Submission", ar: "طلب العميل" },
  step_intake: { en: "Document Intake", ar: "استلام المستندات" },
  step_ai: { en: "Automated Screening", ar: "الفحص الآلي" },
  step_specialist: { en: "Specialist Review", ar: "مراجعة المختص" },
  step_supervisor: { en: "Supervisor Review", ar: "مراجعة المشرف" },
  step_quality: { en: "Quality Review", ar: "مراجعة الجودة" },
  step_deliverable: { en: "Approved Deliverable", ar: "مخرج معتمد" },

  how_title: { en: "A digital VAT department for Saudi companies", ar: "إدارة ضريبية رقمية للشركات السعودية" },
  how_sub: { en: "Every request becomes a governed professional engagement — from intake to quality-approved deliverable.", ar: "كل طلب يتحوّل إلى ارتباط مهني منضبط — من الاستلام حتى مخرج معتمد وفق الجودة." },

  // Feature areas
  feat_health_t: { en: "VAT Health Monitoring", ar: "مراقبة صحة الضريبة" },
  feat_health_d: { en: "A live VAT Health Score across 13 categories with risk indicators.", ar: "مؤشر حي لصحة الضريبة عبر 13 فئة مع مؤشرات المخاطر." },
  feat_return_t: { en: "VAT Return Review", ar: "مراجعة الإقرار الضريبي" },
  feat_return_d: { en: "Reconciliation and specialist review before you approve for filing.", ar: "تسوية ومراجعة المختص قبل اعتمادك للتقديم." },
  feat_zatca_t: { en: "ZATCA Audit Support", ar: "دعم فحص الهيئة" },
  feat_zatca_d: { en: "Manage ZATCA notices, evidence, deadlines and response packages.", ar: "إدارة إشعارات الهيئة والأدلة والمواعيد وحزم الردود." },
  feat_advisory_t: { en: "VAT Advisory", ar: "الاستشارات الضريبية" },
  feat_advisory_d: { en: "Ask a VAT specialist and receive a reviewed advisory note.", ar: "اسأل مختص ضريبي واحصل على مذكرة استشارية مراجعة." },
  feat_docs_t: { en: "VAT Document Checker", ar: "فاحص المستندات" },
  feat_docs_d: { en: "Invoices are classified automatically and mandatory VAT fields extracted.", ar: "تُصنّف الفواتير تلقائياً وتُستخرج الحقول الإلزامية للضريبة." },
  feat_risk_t: { en: "VAT Risk Management", ar: "إدارة المخاطر الضريبية" },
  feat_risk_d: { en: "A living VAT issue register with exposure and remediation tracking.", ar: "سجل حي لقضايا الضريبة مع تتبّع المخاطر والمعالجة." },

  trust_title: { en: "Our specialists own the decision — technology sharpens the accuracy.", ar: "مختصونا يملكون القرار… والتقنية تُعزّز الدقة." },
  trust_body: { en: "A specialist Saudi VAT team runs every engagement — screening, data checks and analysis grounded in the VAT Law and its Implementing Regulations. Smart automation speeds the routine work; the review, judgment and final decision always stay with our specialists, supervisors and quality control.", ar: "فريق سعودي متخصص في ضريبة القيمة المضافة يُدير كل ارتباط — الفحص والتحقق من البيانات والتحليل المبني على النظام ولائحته التنفيذية. تُسرّع الأتمتة الذكية العمل الروتيني، بينما تبقى المراجعة والحكم والقرار النهائي دائماً بأيدي مختصينا ومشرفينا ورقابة الجودة." },

  // Pricing
  pricing_title: { en: "Subscription plans", ar: "باقات الاشتراك" },
  pricing_sub: { en: "Monthly VAT operations, priced by complexity — not just revenue.", ar: "عمليات ضريبية شهرية، مسعّرة حسب التعقيد وليس الإيراد فقط." },
  per_month: { en: "/mo", ar: "/شهرياً" },
  sar: { en: "SAR", ar: "ريال" },
  custom: { en: "Custom", ar: "مخصص" },
  contact_sales: { en: "Contact Sales", ar: "تواصل مع المبيعات" },
  choose_plan: { en: "Choose Plan", ar: "اختر الباقة" },
  current_plan: { en: "Current Plan", ar: "الباقة الحالية" },
  most_popular: { en: "Most Popular", ar: "الأكثر شيوعاً" },
  addons_title: { en: "Add-on professional services", ar: "خدمات مهنية إضافية" },
  addons_sub: { en: "Purchased as separate engagements when work is outside your subscription.", ar: "تُشترى كارتباطات منفصلة عند خروج العمل عن نطاق الاشتراك." },

  // Diagnostic
  diag_title: { en: "Free VAT Diagnostic", ar: "التشخيص الضريبي المجاني" },
  diag_sub: { en: "A 5-minute assessment. Get your VAT complexity, risk areas and a recommended plan.", ar: "تقييم من 5 دقائق. اعرف تعقيد ضريبتك ومناطق المخاطر والباقة الموصى بها." },
  diag_company: { en: "Company name", ar: "اسم المنشأة" },
  diag_email: { en: "Work email", ar: "البريد الوظيفي" },
  diag_sector: { en: "Sector", ar: "القطاع" },
  sector_type: { en: "Sector type", ar: "نوع القطاع" },
  sec_government: { en: "Government Sector", ar: "القطاع الحكومي" },
  sec_private: { en: "Private Sector", ar: "القطاع الخاص" },
  sec_nonprofit: { en: "Non-Profit Sector", ar: "القطاع غير الربحي" },
  diag_entities: { en: "Number of entities", ar: "عدد الكيانات" },
  diag_txn_q: { en: "Which of these apply to your business?", ar: "أي من التالي ينطبق على نشاطك؟" },
  diag_run: { en: "Get My Result", ar: "احصل على النتيجة" },
  diag_result: { en: "Your VAT Diagnostic Result", ar: "نتيجة التشخيص الضريبي" },
  diag_complexity: { en: "VAT Complexity", ar: "تعقيد الضريبة" },
  diag_areas: { en: "Areas requiring attention", ar: "مناطق تتطلب الاهتمام" },
  diag_recommended: { en: "Recommended Plan", ar: "الباقة الموصى بها" },
  diag_disclaimer: { en: "This score is an initial risk indicator and is not a formal tax opinion unless approved by a Growth Curve VAT specialist.", ar: "هذا المؤشر أولي لتقدير المخاطر وليس رأياً ضريبياً رسمياً ما لم يعتمده مختص ضريبي في Growth Curve." },

  // Transactions options (labels)
  txn_domestic: { en: "Domestic sales", ar: "مبيعات محلية" },
  txn_exports: { en: "Exports", ar: "صادرات" },
  txn_imports: { en: "Imports", ar: "واردات" },
  txn_gcc_transactions: { en: "GCC transactions", ar: "معاملات خليجية" },
  txn_non_resident_services: { en: "Services from non-residents", ar: "خدمات من غير المقيمين" },
  txn_reverse_charge: { en: "Reverse charge", ar: "احتساب عكسي" },
  txn_exempt_supplies: { en: "Exempt supplies", ar: "توريدات معفاة" },
  txn_government_contracts: { en: "Government contracts", ar: "عقود حكومية" },
  txn_real_estate: { en: "Real estate", ar: "عقارات" },
  txn_capital_assets: { en: "Capital assets", ar: "أصول رأسمالية" },
  txn_credit_notes: { en: "Credit notes", ar: "إشعارات دائنة" },
  txn_intercompany: { en: "Intercompany transactions", ar: "معاملات بين الشركات" },
  txn_related_party: { en: "Related party transactions", ar: "أطراف ذات علاقة" },

  // Auth
  register_title: { en: "Create your account", ar: "أنشئ حسابك" },
  register_sub: { en: "Start your VAT operations with Growth Curve.", ar: "ابدأ عملياتك الضريبية مع Growth Curve." },
  login_title: { en: "Welcome back", ar: "مرحباً بعودتك" },
  login_sub: { en: "Sign in to your VAT platform.", ar: "سجّل الدخول إلى منصتك الضريبية." },
  full_name: { en: "Full name", ar: "الاسم الكامل" },
  email: { en: "Email", ar: "البريد الإلكتروني" },
  password: { en: "Password", ar: "كلمة المرور" },
  company_name: { en: "Company name", ar: "اسم المنشأة" },
  tin: { en: "VAT / TIN number", ar: "الرقم الضريبي (TIN)" },
  cr_number: { en: "CR number", ar: "السجل التجاري" },
  no_account: { en: "Don't have an account?", ar: "ليس لديك حساب؟" },
  identifier_label: { en: "Email or VAT number (TIN)", ar: "البريد الإلكتروني أو الرقم المميز" },
  identifier_ph: { en: "name@company.com  or  3XXXXXXXXXXXX3", ar: "name@company.com  أو  3XXXXXXXXXXXX3" },
  phone: { en: "Mobile number", ar: "رقم الجوال" },
  continue_google: { en: "Continue with Google", ar: "المتابعة عبر Google" },
  quick_access: { en: "Quick access — no sign-up", ar: "دخول سريع — بدون بيانات" },
  quick_access_hint: { en: "Instantly explore the platform with a temporary account.", ar: "استكشف المنصة فوراً عبر حساب مؤقت." },
  or_sep: { en: "or", ar: "أو" },
  have_account: { en: "Already have an account?", ar: "لديك حساب بالفعل؟" },
  sign_up: { en: "Sign up", ar: "إنشاء حساب" },
  sign_in: { en: "Sign in", ar: "دخول" },

  // App shell
  nav_cases: { en: "Cases", ar: "الحالات" },
  nav_documents: { en: "Document Room", ar: "غرفة المستندات" },
  nav_new_request: { en: "New Request", ar: "طلب جديد" },
  nav_subscription: { en: "Subscription", ar: "الاشتراك" },
  nav_assistant: { en: "AI Assistant", ar: "المساعد الذكي" },
  nav_notifications: { en: "Notifications", ar: "الإشعارات" },
  nav_timeline: { en: "Timeline", ar: "الخط الزمني" },
  print_report: { en: "Print / PDF Report", ar: "طباعة / تقرير PDF" },
  report_title: { en: "VAT Engagement Report", ar: "تقرير ارتباط ضريبي" },
  quick_demo: { en: "Quick demo login as", ar: "دخول تجريبي سريع كـ" },
  back: { en: "Back", ar: "رجوع" },
  sec_hint_government: { en: "Distinguish sovereign activities (outside VAT) from commercial supplies (taxable).", ar: "افصل الأنشطة السيادية (خارج الضريبة) عن التوريدات التجارية (خاضعة)." },
  sec_hint_private: { en: "Standard VAT rules apply to your supplies.", ar: "تنطبق قواعد الضريبة الاعتيادية على توريداتك." },
  sec_hint_nonprofit: { en: "Donations are outside scope, but commercial supplies (e.g. commercial rent) are taxable at 15%.", ar: "التبرعات خارج النطاق، لكن التوريدات التجارية (مثل الإيجار التجاري) خاضعة 15%." },
  nav_queue: { en: "Work Queue", ar: "قائمة العمل" },
  nav_management: { en: "Management", ar: "الإدارة" },
  nav_workload: { en: "Workload", ar: "أحمال العمل" },
  nav_users: { en: "Users", ar: "المستخدمون" },
  nav_clients: { en: "Clients", ar: "العملاء" },

  // Dashboard
  vat_health_score: { en: "VAT Health Score", ar: "مؤشر صحة الضريبة" },
  open_issues: { en: "Open VAT Issues", ar: "قضايا ضريبية مفتوحة" },
  high_risk: { en: "High Risk", ar: "مخاطر عالية" },
  awaiting_documents: { en: "Awaiting Documents", ar: "بانتظار المستندات" },
  next_filing: { en: "Next VAT Filing", ar: "الإقرار القادم" },
  days: { en: "days", ar: "يوم" },
  open_cases: { en: "Open Cases", ar: "حالات مفتوحة" },
  zatca_cases: { en: "ZATCA Cases", ar: "حالات الهيئة" },
  recent_cases: { en: "Recent Cases", ar: "أحدث الحالات" },
  view_all: { en: "View all", ar: "عرض الكل" },
  welcome: { en: "Welcome", ar: "مرحباً" },

  // Cases
  reference: { en: "Reference", ar: "المرجع" },
  service: { en: "Service", ar: "الخدمة" },
  status: { en: "Status", ar: "الحالة" },
  priority: { en: "Priority", ar: "الأولوية" },
  created: { en: "Created", ar: "أنشئت" },
  deadline: { en: "Deadline", ar: "الموعد النهائي" },
  assigned: { en: "Assigned Specialist", ar: "المختص المكلّف" },
  no_cases: { en: "No cases yet.", ar: "لا توجد حالات بعد." },
  open_case: { en: "Open", ar: "فتح" },

  // Case detail
  overview: { en: "Overview", ar: "نظرة عامة" },
  findings: { en: "Findings", ar: "الملاحظات" },
  documents: { en: "Documents", ar: "المستندات" },
  doc_requests: { en: "Document Requests", ar: "طلبات المستندات" },
  ai_analysis: { en: "AI Preliminary Analysis", ar: "التحليل الأولي بالذكاء الاصطناعي" },
  client_summary: { en: "For You (Client Summary)", ar: "لك (ملخص العميل)" },
  specialist_detail: { en: "Specialist Analysis", ar: "تحليل المختص" },
  regulatory_refs: { en: "Regulatory References", ar: "المراجع النظامية" },
  timeline: { en: "Timeline", ar: "التسلسل الزمني" },
  feedback: { en: "Your Feedback", ar: "تقييمك" },
  rate_service: { en: "How was this deliverable?", ar: "كيف كان هذا المخرج؟" },
  submit_feedback: { en: "Submit Feedback", ar: "إرسال التقييم" },
  thank_feedback: { en: "Thank you for your feedback.", ar: "شكراً لتقييمك." },
  audit_trail: { en: "Audit Trail", ar: "سجل التدقيق" },
  comments: { en: "Comments", ar: "التعليقات" },
  sources: { en: "Sources & Regulations", ar: "المصادر والأنظمة" },
  qc_checklist: { en: "QC Checklist", ar: "قائمة فحص الجودة" },
  run_ai: { en: "Run AI Screening", ar: "تشغيل الفحص الذكي" },
  take_case: { en: "Take Case", ar: "استلام الحالة" },
  request_info: { en: "Request Information", ar: "طلب معلومات" },
  submit_supervisor: { en: "Submit to Supervisor", ar: "إرسال للمشرف" },
  supervisor_approve: { en: "Approve → Quality", ar: "اعتماد ← الجودة" },
  supervisor_return: { en: "Return to Specialist", ar: "إعادة للمختص" },
  quality_approve: { en: "Approve & Release", ar: "اعتماد وإصدار" },
  quality_return: { en: "Return to Supervisor", ar: "إعادة للمشرف" },
  client_approve: { en: "Approve Deliverable", ar: "اعتماد المخرج" },
  add_finding: { en: "Add Finding", ar: "إضافة ملاحظة" },
  add_doc_request: { en: "Request Document", ar: "طلب مستند" },
  risk_level: { en: "Risk", ar: "الخطورة" },
  confidence: { en: "Confidence", ar: "مستوى الثقة" },
  recommendation: { en: "Recommendation", ar: "التوصية" },
  category: { en: "Category", ar: "الفئة" },
  description: { en: "Description", ar: "الوصف" },
  exec_summary: { en: "Executive Summary", ar: "الملخص التنفيذي" },
  transactions_reviewed: { en: "Transactions Reviewed", ar: "معاملات مُراجعة" },
  exceptions: { en: "Exceptions Identified", ar: "استثناءات مرصودة" },
  overall_risk: { en: "Overall Risk", ar: "الخطورة الإجمالية" },
  prepared_by: { en: "Prepared by", ar: "أعدّها" },
  reviewed_by: { en: "Reviewed by", ar: "راجعها" },
  quality_approved_by: { en: "Quality approved by", ar: "اعتمدها الجودة" },
  supervisor_approved: { en: "Supervisor approved", ar: "اعتماد المشرف" },
  add_comment: { en: "Add a comment...", ar: "أضف تعليقاً..." },
  send: { en: "Send", ar: "إرسال" },
  received: { en: "Received", ar: "مستلم" },
  pending: { en: "Pending", ar: "معلّق" },
  required: { en: "Required", ar: "مطلوب" },
  optional: { en: "Optional", ar: "اختياري" },
  upload: { en: "Upload", ar: "رفع" },
  four_eyes: { en: "Four-Eyes Review", ar: "مراجعة رباعية العيون" },

  // New request
  new_request_title: { en: "Submit a new request", ar: "إرسال طلب جديد" },
  new_request_sub: { en: "Choose a service. Your request becomes a governed professional case.", ar: "اختر خدمة. يتحوّل طلبك إلى حالة مهنية منضبطة." },
  title_field: { en: "Title", ar: "العنوان" },
  question_field: { en: "Your VAT question", ar: "سؤالك الضريبي" },
  amount_field: { en: "Amount (SAR)", ar: "المبلغ (ريال)" },
  counterparty_field: { en: "Counterparty", ar: "الطرف الآخر" },
  country_field: { en: "Country", ar: "الدولة" },
  notice_type_field: { en: "Notice type", ar: "نوع الإشعار" },
  ref_number_field: { en: "ZATCA reference number", ar: "الرقم المرجعي للهيئة" },
  submit_request: { en: "Submit Request", ar: "إرسال الطلب" },

  // Documents room
  docroom_title: { en: "Secure Document Room", ar: "غرفة المستندات الآمنة" },
  docroom_sub: { en: "Your confidential documents, organized by folder. Access is role-based and logged.", ar: "مستنداتك السرية منظّمة بالمجلدات. الوصول قائم على الدور ومسجّل." },
  upload_document: { en: "Upload Document", ar: "رفع مستند" },
  folder: { en: "Folder", ar: "المجلد" },
  all_folders: { en: "All folders", ar: "كل المجلدات" },
  no_documents: { en: "No documents in this folder.", ar: "لا توجد مستندات في هذا المجلد." },
  uploaded_by: { en: "Uploaded by", ar: "رفعه" },
  download: { en: "Download", ar: "تنزيل" },

  // Subscription
  sub_title: { en: "Subscription & Billing", ar: "الاشتراك والفوترة" },
  your_plan: { en: "Your Plan", ar: "باقتك" },
  status_active: { en: "Active", ar: "نشط" },
  status_trial: { en: "Trial", ar: "تجريبي" },
  advisory_credits: { en: "Advisory Credits", ar: "رصيد الاستشارات" },
  billing_history: { en: "Billing History", ar: "سجل الفوترة" },
  amount: { en: "Amount", ar: "المبلغ" },
  cycle: { en: "Cycle", ar: "الدورة" },
  monthly: { en: "Monthly", ar: "شهري" },
  annual: { en: "Annual", ar: "سنوي" },
  paid: { en: "Paid", ar: "مدفوع" },
  no_plan: { en: "No active subscription. Choose a plan to activate your VAT operations.", ar: "لا يوجد اشتراك نشط. اختر باقة لتفعيل عملياتك الضريبية." },

  // Onboarding
  onb_title: { en: "VAT Onboarding", ar: "التهيئة الضريبية" },
  onb_sub: { en: "Tell us about your business so we can build your VAT profile and health score.", ar: "أخبرنا عن نشاطك لنبني ملفك الضريبي ومؤشر صحتك." },
  entity_type: { en: "Entity type", ar: "نوع الكيان" },
  branches: { en: "Number of branches", ar: "عدد الفروع" },
  vat_group: { en: "Part of a VAT group", ar: "ضمن مجموعة ضريبية" },
  annual_revenue: { en: "Annual revenue", ar: "الإيراد السنوي" },
  filing_frequency: { en: "Filing frequency", ar: "دورية الإقرار" },
  quarterly: { en: "Quarterly", ar: "ربع سنوي" },
  accounting_system: { en: "Accounting system / ERP", ar: "النظام المحاسبي / ERP" },
  save_profile: { en: "Save VAT Profile", ar: "حفظ الملف الضريبي" },

  // Assistant
  assistant_title: { en: "VAT AI Assistant", ar: "المساعد الضريبي الذكي" },
  assistant_placeholder: { en: "Ask about your VAT status, deadlines, risks or general VAT concepts...", ar: "اسأل عن حالتك الضريبية أو المواعيد أو المخاطر أو مفاهيم الضريبة..." },
  assistant_hint: { en: "AI responses are preliminary. Client-specific or high-risk opinions are escalated for VAT specialist review.", ar: "ردود الذكاء الاصطناعي أولية. تُحال الآراء الخاصة بالعميل أو عالية المخاطر لمراجعة المختص." },

  // Management
  mrr: { en: "MRR", ar: "الإيراد الشهري" },
  arr: { en: "ARR", ar: "الإيراد السنوي" },
  active_clients: { en: "Active Clients", ar: "عملاء نشطون" },
  total_cases: { en: "Total Cases", ar: "إجمالي الحالات" },
  cases_by_risk: { en: "Cases by Risk", ar: "الحالات حسب المخاطر" },
  cases_by_status: { en: "Cases by Status", ar: "الحالات حسب المرحلة" },
  sla_perf: { en: "SLA Performance", ar: "أداء مستوى الخدمة" },
  avg_review: { en: "Avg Review Time (h)", ar: "متوسط زمن المراجعة (س)" },
  rework_rate: { en: "Quality Rework Rate", ar: "معدل إعادة العمل" },
  leads: { en: "Diagnostic Leads", ar: "عملاء محتملون" },
  specialist_queue: { en: "Specialist Queue", ar: "قائمة المختص" },
  supervisor_queue: { en: "Supervisor Queue", ar: "قائمة المشرف" },
  quality_queue: { en: "Quality Queue", ar: "قائمة الجودة" },
  assigned_cases: { en: "Assigned", ar: "مكلّف" },
  pending_cases: { en: "Pending", ar: "معلّق" },

  // Users admin
  add_user: { en: "Add Staff User", ar: "إضافة مستخدم" },
  role: { en: "Role", ar: "الدور" },
  create: { en: "Create", ar: "إنشاء" },
  name: { en: "Name", ar: "الاسم" },

  // Misc
  loading: { en: "Loading...", ar: "جارٍ التحميل..." },
  saved: { en: "Saved", ar: "تم الحفظ" },
  disclaimer_note: { en: "AI outputs are preliminary until professionally reviewed. The client remains responsible for the completeness and accuracy of source information. Final actions require client approval.", ar: "مخرجات الذكاء الاصطناعي أولية حتى تتم مراجعتها مهنياً. يبقى العميل مسؤولاً عن اكتمال ودقة البيانات المصدرية. تتطلب الإجراءات النهائية اعتماد العميل." },
  confirm_release: { en: "Confirm & Send to Client", ar: "تأكيد وإرسال للعميل" },
  ai_waiting_title: { en: "Preliminary analysis awaiting specialist confirmation", ar: "التحليل الأولي بانتظار تأكيد المختص" },
  ai_waiting_body: { en: "We received your inquiry and the system prepared a preliminary analysis with regulatory references. A VAT specialist is reviewing it and will confirm before it is shared with you.", ar: "تم استلام استفسارك وجهّز النظام تحليلاً أولياً مع المراجع النظامية. يقوم المختص الضريبي بمراجعته وسيؤكده قبل مشاركته معك." },
  sector_activity: { en: "Activity / Sub-sector", ar: "النشاط / التصنيف" },
  select_ph: { en: "Select…", ar: "اختر…" },
  view_sample_journey: { en: "View a sample journey", ar: "شاهد رحلة نموذجية" },
  methodology: { en: "Service methodology", ar: "منهجية الخدمة" },
  fw_inputs: { en: "Inputs", ar: "المدخلات" },
  fw_measures: { en: "Measures", ar: "التدابير" },
  fw_outputs: { en: "Outputs", ar: "المخرجات" },
  time_log: { en: "Time Log", ar: "سجل الوقت" },
  minutes: { en: "Minutes", ar: "دقائق" },
  hours: { en: "hrs", ar: "ساعة" },
  add_time: { en: "Log Time", ar: "تسجيل الوقت" },
  total_time: { en: "Total time", ar: "إجمالي الوقت" },
  time_note: { en: "What did you work on?", ar: "على ماذا عملت؟" },
  hours_worked: { en: "Hours worked", ar: "ساعات العمل" },
  nav_time_report: { en: "Time Report", ar: "تقرير الوقت" },
  nav_summary: { en: "Engagement Summary", ar: "ملخص التعاقد" },
  time_report_title: { en: "Consultant Time Report", ar: "تقرير وقت المستشارين" },
  export_csv: { en: "Export CSV", ar: "تصدير CSV" },
  consultant: { en: "Consultant", ar: "المستشار" },
  start_timer: { en: "Start timer", ar: "ابدأ المؤقت" },
  stop_timer: { en: "Stop & log", ar: "أوقف وسجّل" },
  timer_session: { en: "Timed session", ar: "جلسة موقّتة" },
  plan_label: { en: "Plan", ar: "الباقة" },
  invoices: { en: "Invoices", ar: "الفواتير" },
  total_spend: { en: "Total spend", ar: "إجمالي الإنفاق" },
  total_hours: { en: "Total hours", ar: "إجمالي الساعات" },
  amount: { en: "Amount", ar: "المبلغ" },
  paid: { en: "Paid", ar: "مدفوعة" },
  pay_card: { en: "Pay by card", ar: "ادفع بالبطاقة" },
  pay_bank: { en: "Bank transfer", ar: "تحويل بنكي" },
  bank_beneficiary: { en: "Beneficiary", ar: "المستفيد" },
  bank_name: { en: "Bank", ar: "البنك" },
  bank_ref: { en: "Reference", ar: "المرجع" },
  bank_note: { en: "Transfer the amount and send the receipt; your plan activates once we confirm the payment.", ar: "حوّل المبلغ وأرسل الإيصال؛ يُفعّل اشتراكك بعد تأكيد استلام الدفعة." },
  bank_done: { en: "Done", ar: "تم" },
  nav_knowledge: { en: "Knowledge", ar: "مركز المعرفة" },
  knowledge_center: { en: "Knowledge Center", ar: "مركز المعرفة" },
  decisions_tab: { en: "Committee Decisions", ar: "قرارات اللجان" },
  articles_tab: { en: "Guides", ar: "مقالات تثقيفية" },
  kn_search_ph: { en: "Search decisions…", ar: "ابحث في القرارات…" },
  all_committees: { en: "All committees", ar: "كل الدوائر" },
  all_years: { en: "All years", ar: "كل السنوات" },
  decision_basis: { en: "Legal basis", ar: "الأسانيد النظامية" },
  decision_outcome: { en: "Outcome", ar: "النتيجة" },
  official_source: { en: "Official source", ar: "المصدر الرسمي" },
  dtype_procedural: { en: "Procedural", ar: "شكلي" },
  dtype_substantive: { en: "Substantive", ar: "موضوعي" },
  kn_disclaimer: { en: "Curated summaries for guidance; refer to the official GSTC source for the full ruling.", ar: "ملخصات استرشادية؛ يُرجع للمصدر الرسمي للأمانة للاطلاع على نص القرار كاملاً." },
  test_card_hint: { en: "Test mode — use card 4242 4242 4242 4242, any future date & CVC.", ar: "الوضع الاختباري — استخدم البطاقة 4242 4242 4242 4242 بأي تاريخ مستقبلي ورمز." },
  no_data: { en: "No data yet", ar: "لا توجد بيانات بعد" },
  related_decisions: { en: "Related committee decisions", ar: "قرارات لجان ذات صلة" },
  add_decision: { en: "Add a decision", ar: "إضافة قرار" },
  kn_save: { en: "Save decision", ar: "حفظ القرار" },
  nav_toolkit: { en: "AI VAT Toolkit", ar: "مساعد الضريبة AI" },
  nav_structure: { en: "VAT Operations", ar: "العمليات الضريبية" },
  nav_knowledge_sources: { en: "Source Governance", ar: "حوكمة المصادر" },
  nav_portal: { en: "Compliance Portal", ar: "بوابة الامتثال" },
  tk_title: { en: "AI VAT Toolkit", ar: "مساعد الضريبة بالذكاء الاصطناعي" },
  tk_sub: { en: "Specialist AI tools for Saudi VAT — preliminary output, requires specialist confirmation.", ar: "أدوات ذكاء اصطناعي للمختصين في ضريبة القيمة المضافة السعودية — مخرجات أولية تتطلب تأكيد المختص." },
  tk_disclaimer: { en: "Preliminary AI output for internal specialist use only. Not client-facing until confirmed.", ar: "مخرجات أولية للاستخدام الداخلي للمختصين فقط. لا تُعرض على العميل قبل الاعتماد." },
  tk_tab_research: { en: "VAT Research", ar: "بحث ضريبي" },
  tk_tab_document: { en: "Document Analysis", ar: "تحليل مستند" },
  tk_tab_draft: { en: "Client Communication", ar: "صياغة مراسلات" },
  tk_tab_variance: { en: "Return Variance", ar: "انحرافات الإقرار" },
  tk_tab_forecast: { en: "Liability Estimate", ar: "تقدير الالتزام" },
  tk_run: { en: "Run AI", ar: "تشغيل الذكاء الاصطناعي" },
  tk_running: { en: "Working…", ar: "جارٍ التنفيذ…" },
  tk_copy: { en: "Copy", ar: "نسخ" },
  tk_copied: { en: "Copied", ar: "تم النسخ" },
  tk_answer: { en: "Answer", ar: "الإجابة" },
  tk_key_points: { en: "Key points", ar: "أهم النقاط" },
  tk_references: { en: "Regulatory references", ar: "الأسانيد النظامية" },
  tk_confidence: { en: "Confidence", ar: "درجة الثقة" },
  tk_research_ph: { en: "Ask a Saudi VAT question, e.g. reverse charge on foreign SaaS…", ar: "اطرح سؤالاً ضريبياً، مثال: الاحتساب العكسي على خدمات SaaS الأجنبية…" },
  tk_sector: { en: "Sector", ar: "القطاع" },
  tk_sector_private: { en: "Private", ar: "خاص" },
  tk_sector_government: { en: "Government", ar: "حكومي" },
  tk_sector_nonprofit: { en: "Non-profit / Waqf", ar: "غير ربحي / وقف" },
  tk_doc_ph: { en: "Paste invoice / document text here…", ar: "الصق نص الفاتورة أو المستند هنا…" },
  tk_doc_type: { en: "Document type", ar: "نوع المستند" },
  tk_doc_result: { en: "Result", ar: "النتيجة" },
  tk_doc_fields: { en: "Extracted fields", ar: "الحقول المستخرجة" },
  tk_doc_missing: { en: "Missing / to review", ar: "ناقص / للمراجعة" },
  tk_draft_audience: { en: "Audience", ar: "الجهة" },
  tk_aud_client: { en: "Client", ar: "العميل" },
  tk_aud_zatca: { en: "ZATCA", ar: "هيئة الزكاة والضريبة" },
  tk_aud_internal: { en: "Internal", ar: "داخلي" },
  tk_draft_purpose: { en: "Purpose", ar: "الغرض" },
  tk_draft_purpose_ph: { en: "e.g. Request missing export evidence", ar: "مثال: طلب أدلة التصدير الناقصة" },
  tk_draft_points: { en: "Key points (one per line)", ar: "النقاط الأساسية (كل نقطة بسطر)" },
  tk_draft_tone: { en: "Tone", ar: "النبرة" },
  tk_tone_professional: { en: "Professional", ar: "مهني" },
  tk_tone_formal: { en: "Formal", ar: "رسمي" },
  tk_tone_friendly: { en: "Friendly", ar: "ودّي" },
  tk_subject: { en: "Subject", ar: "الموضوع" },
  tk_body: { en: "Message", ar: "نص الرسالة" },
  tk_var_current: { en: "Current period", ar: "الفترة الحالية" },
  tk_var_previous: { en: "Previous period", ar: "الفترة السابقة" },
  tk_summary: { en: "Summary", ar: "الملخص" },
  tk_var_checks: { en: "Recommended checks", ar: "الفحوصات الموصى بها" },
  tk_f_standard_sales: { en: "Standard-rated sales", ar: "مبيعات خاضعة (١٥٪)" },
  tk_f_zero_sales: { en: "Zero-rated sales", ar: "مبيعات بنسبة صفر" },
  tk_f_exempt_sales: { en: "Exempt sales", ar: "مبيعات معفاة" },
  tk_f_standard_purchases: { en: "Standard-rated purchases", ar: "مشتريات خاضعة (١٥٪)" },
  tk_f_imports: { en: "Imports (goods)", ar: "الواردات (سلع)" },
  tk_f_prior_credit: { en: "Prior period credit", ar: "رصيد دائن سابق" },
  tk_output_vat: { en: "Output VAT", ar: "ضريبة المخرجات" },
  tk_input_vat: { en: "Input VAT", ar: "ضريبة المدخلات" },
  tk_net_due: { en: "Net VAT due", ar: "صافي الضريبة المستحقة" },
  tk_position: { en: "Position", ar: "المركز" },
  tk_pos_payable: { en: "Payable", ar: "مستحقة الدفع" },
  tk_pos_refundable: { en: "Refundable", ar: "قابلة للاسترداد" },
  tk_pos_nil: { en: "Nil", ar: "لا شيء" },
  tk_commentary: { en: "Specialist commentary", ar: "ملاحظات المختص" },
  tk_watch: { en: "Watch points", ar: "نقاط للانتباه" },
  tk_empty: { en: "Fill the inputs and run the AI to see results.", ar: "أدخل البيانات وشغّل الذكاء الاصطناعي لعرض النتائج." },
  tk_sop: { en: "SOP / Blueprint", ar: "دليل الإجراءات (SOP)" },
  tk_save_draft: { en: "Save as case draft", ar: "حفظ كمسودة قضية" },
  tk_select_case: { en: "Select a case…", ar: "اختر قضية…" },
  tk_draft_saved: { en: "Saved as a draft inside the case (internal).", ar: "حُفظت كمسودة داخل القضية (داخلية)." },
  tk_no_open_cases: { en: "No open cases available.", ar: "لا توجد قضايا مفتوحة." },
  drafts_title: { en: "Specialist drafts (internal)", ar: "مسودات المختص (داخلية)" },
  draft_kind_research: { en: "VAT research", ar: "بحث ضريبي" },
  draft_kind_communication: { en: "Communication", ar: "مراسلة" },
  draft_delete: { en: "Delete", ar: "حذف" },
  tk_tab_advisor: { en: "VAT Advisor Bot", ar: "البوت الاستشاري" },
  tk_adv_q_ph: { en: "Describe the case / situation in detail…", ar: "صف الحالة / الواقعة بالتفصيل…" },
  tk_adv_amount: { en: "Amount (SAR, optional)", ar: "المبلغ (ريال، اختياري)" },
  tk_adv_counterparty: { en: "Counterparty (optional)", ar: "الطرف الآخر (اختياري)" },
  tk_adv_country: { en: "Country (optional)", ar: "الدولة (اختياري)" },
  tk_adv_facts: { en: "Case as understood", ar: "الحالة كما فُهمت" },
  tk_adv_basis: { en: "Regulatory basis", ar: "الأسانيد النظامية" },
  tk_adv_solution: { en: "Optimal treatment", ar: "الحل الأمثل / المعالجة" },
  tk_adv_detail: { en: "Specialist reasoning", ar: "التعليل الفني للمختص" },
  tk_adv_risks: { en: "Risks", ar: "توضيح المخاطر" },
  tk_adv_required_docs: { en: "Required documents", ar: "المستندات المطلوبة" },
  tk_adv_missing: { en: "Missing facts", ar: "الحقائق الناقصة" },
  tk_doc_upload: { en: "Upload PDF / image", ar: "رفع PDF / صورة" },
  tk_doc_or: { en: "— or paste text —", ar: "— أو الصق النص —" },
  tk_doc_analyzing_file: { en: "Analyzing file…", ar: "جارٍ تحليل الملف…" },
  tk_tax: { en: "Tax", ar: "نوع الضريبة" },
  tk_tax_vat: { en: "VAT", ar: "القيمة المضافة" },
  tk_tax_excise: { en: "Excise", ar: "الانتقائية" },
  tk_tax_rett: { en: "Real Estate (RETT)", ar: "التصرفات العقارية" },
  kn_all_tax: { en: "All taxes", ar: "كل الضرائب" },
  tk_adv_precedents: { en: "Similar prior committee decisions", ar: "حالات/قرارات سابقة مماثلة (سوابق اللجان)" },
  nav_leads: { en: "Service Requests", ar: "طلبات الخدمة" },
  leads_sub: { en: "Incoming service requests from the tax pages", ar: "طلبات الخدمة الواردة من صفحات الضرائب" },
  leads_name: { en: "Name", ar: "الاسم" },
  leads_contact: { en: "Contact", ar: "التواصل" },
  leads_message: { en: "Message", ar: "الرسالة" },
  leads_date: { en: "Date", ar: "التاريخ" },
  leads_empty: { en: "No service requests yet.", ar: "لا توجد طلبات خدمة بعد." },
  nav_tax_services: { en: "Tax Services", ar: "الخدمات الضريبية" },
  tax_services_title: { en: "Three taxes, one platform", ar: "ثلاث ضرائب، منصة واحدة" },
  tax_services_sub: { en: "We cover the three Saudi taxes end-to-end — screening, compliance, advisory and audit support, led by professional specialists with technology support.", ar: "نغطّي الضرائب السعودية الثلاث من البداية للنهاية — فحص وامتثال واستشارات ودعم تدقيق، يقودها مختصون مهنيون بدعم من التقنية." },
  tax_services_cta: { en: "Request advisory", ar: "اطلب استشارة" },
  tax_vat_name: { en: "Value Added Tax", ar: "ضريبة القيمة المضافة" },
  tax_vat_rate: { en: "15%", ar: "15٪" },
  tax_vat_desc: { en: "Health checks, compliance, advisory and ZATCA audit support for VAT — grounded in the Law and Implementing Regulations.", ar: "فحص وامتثال واستشارات ودعم تدقيق هيئة الزكاة والضريبة — مع الأسانيد من النظام واللائحة التنفيذية." },
  tax_excise_name: { en: "Excise Tax", ar: "الضريبة الانتقائية" },
  tax_excise_rate: { en: "50–100%", ar: "50–100٪" },
  tax_excise_desc: { en: "Registration, computation and compliance for excise on tobacco, energy drinks, and carbonated & sweetened drinks.", ar: "تسجيل واحتساب وامتثال للضريبة الانتقائية على التبغ ومشروبات الطاقة والمشروبات الغازية والمحلاة." },
  tax_rett_name: { en: "Real Estate Transaction Tax", ar: "ضريبة التصرفات العقارية" },
  tax_rett_rate: { en: "5%", ar: "5٪" },
  tax_rett_desc: { en: "Computation and handling of the 5% tax on property disposals, including exemptions and ZATCA filing.", ar: "احتساب ومعالجة ضريبة 5٪ على التصرف في العقارات، شاملة الإعفاءات والإقرار لدى الهيئة." },
  nav_ai_workspace: { en: "Tax Workspace", ar: "مساحة العمل الضريبية" },
  language: { en: "English", ar: "عربي" },
};

// Role labels
export const ROLE_LABELS = {
  client_admin: { en: "Client Admin", ar: "مدير العميل" },
  client_user: { en: "Client User", ar: "مستخدم العميل" },
  vat_specialist: { en: "VAT Specialist", ar: "مختص ضريبي" },
  supervisor: { en: "Supervisor", ar: "مشرف" },
  quality_reviewer: { en: "Quality Reviewer", ar: "مراجع الجودة" },
  platform_admin: { en: "Platform Admin", ar: "مدير المنصة" },
  management: { en: "Management", ar: "الإدارة" },
};

export const STATUS_LABELS = {
  new: { en: "New", ar: "جديدة" },
  awaiting_documents: { en: "Awaiting Documents", ar: "بانتظار المستندات" },
  documents_received: { en: "Documents Received", ar: "استُلمت المستندات" },
  ai_review: { en: "AI Review", ar: "مراجعة آلية" },
  specialist_review: { en: "Specialist Review", ar: "مراجعة المختص" },
  additional_info_required: { en: "Additional Info Required", ar: "مطلوب معلومات" },
  supervisor_review: { en: "Supervisor Review", ar: "مراجعة المشرف" },
  quality_review: { en: "Quality Review", ar: "مراجعة الجودة" },
  client_approval: { en: "Client Approval", ar: "اعتماد العميل" },
  completed: { en: "Completed", ar: "مكتملة" },
  closed: { en: "Closed", ar: "مغلقة" },
};

export const QC_LABELS = {
  facts_match_evidence: { en: "Facts match evidence", ar: "تطابق الحقائق مع الأدلة" },
  calculations_verified: { en: "Calculations verified", ar: "التحقق من الحسابات" },
  source_citation: { en: "Source citation present", ar: "وجود المصادر" },
  vat_treatment: { en: "VAT treatment correct", ar: "صحة المعالجة الضريبية" },
  consistency: { en: "Internal consistency", ar: "الاتساق الداخلي" },
  professional_language: { en: "Professional language", ar: "اللغة المهنية" },
  limitation_wording: { en: "Limitation wording", ar: "صياغة التحفظات" },
  client_assumptions: { en: "Client assumptions stated", ar: "افتراضات العميل موضّحة" },
  missing_information: { en: "Missing information noted", ar: "الإشارة للمعلومات الناقصة" },
  final_recommendation: { en: "Final recommendation clear", ar: "وضوح التوصية النهائية" },
};

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("gc_lang") || "ar");
  const dir = lang === "ar" ? "rtl" : "ltr";

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = dir;
    localStorage.setItem("gc_lang", lang);
  }, [lang, dir]);

  const t = useCallback((key) => (STR[key] ? STR[key][lang] : key), [lang]);
  const toggle = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);
  const fmt = useCallback((n) => new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-US").format(n || 0), [lang]);
  const pick = useCallback((obj) => (obj ? obj[lang] : ""), [lang]);

  return (
    <I18nContext.Provider value={{ lang, dir, t, setLang, toggle, fmt, pick }}>
      {children}
    </I18nContext.Provider>
  );
}

export function useI18n() {
  return useContext(I18nContext);
}
